import React, { useState, useContext, useCallback, useMemo, useEffect } from 'react';
import { UserContext } from '../../../contexts/userProvider';
import { ClientContext } from '../../../contexts/clientProvider';
import LoadingSpinner from '../../Loader/load';
import GeralCadastro from '../Cadastrar/geralCadastro';
import FinanceiroCadastro from '../Cadastrar/financeiroCadastro';
import ComercialCadastro from '../Cadastrar/comercialCadastro';
import TecnicaCadastro from '../Cadastrar/tecnicaCadastro';
import ContratoCadastro from '../Cadastrar/contratoCadastro';
import ItensCadastro from '../Cadastrar/itens';
import ObservacaoCadastro from '../Cadastrar/observacaoCadastro';
import TabNavigation from '../../General/TabNavigation';
import { formatCpfCnpj } from '../../General/Utils/formatCpfCnpj';

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const Cadastro = ({ onTabChange }) => {
  const { user, setAlert } = useContext(UserContext);
  const { createCliente } = useContext(ClientContext);
  const [activeTab, setActiveTab] = useState('geral');
  const [newClient, setNewClient] = useState({});
  const [loading, setLoading] = useState(false);

  // Atualiza o campo cpf_cnpj formatado
  useEffect(() => {
    if (newClient.cpf_cnpj) {
      const formatted = formatCpfCnpj(newClient.cpf_cnpj);
      if (formatted !== newClient.cpf_cnpj) {
        setNewClient((prevData) => ({ ...prevData, cpf_cnpj: formatted }));
      }
    }
  }, [newClient.cpf_cnpj]);

  // Manipula mudanças nos inputs
  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setNewClient((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  // Validação e salvamento do cliente
  const handleSave = useCallback(async () => {
    for (const key of Object.keys(newClient)) {
      if (key.toLowerCase().includes('email')) {
        const email = newClient[key];
        if (email && !isValidEmail(email)) {
          setAlert({
            type: 'warning',
            placeholder: `E-mail inválido no campo ${key}`,
            visible: true,
            confirm: false,
            title: 'Atenção!'
          });
          return;
        }
      }
    }

    if (!newClient?.nome || !newClient.cpf_cnpj) {
      setAlert({
        type: 'warning',
        placeholder: 'Nome e CPF/CNPJ são obrigatórios',
        visible: true,
        confirm: false,
        title: 'Atenção!'
      });
      return;
    }

    const clientToSave = {
      ...newClient,
      ativo: true,
      id_usuario: user.id,
      usuario: user.nome,
      created_at: new Date(),
      updated_at: new Date()
    };

    const {
      contrato_nome, contrato_numero, contrato_tipo, contrato_valor,
      contrato_data_inicio, contrato_data_fim, ...clienteLimpo
    } = clientToSave;
    const contrato = {
      nome: contrato_nome, numero: contrato_numero, tipo: contrato_tipo,
      valor: contrato_valor, data_inicio: contrato_data_inicio, data_fim: contrato_data_fim,
    };
    const payloadCliente = { ...clienteLimpo, contrato };

    setLoading(true);
    const ok = await createCliente(payloadCliente);
    setLoading(false);
    if (ok === true) {
      if (onTabChange) onTabChange('consulta');
    }
  }, [newClient, setAlert, user, createCliente, onTabChange]);

  const tabs = [
    {
      key: 'geral',
      label: 'Geral',
      icon: 'config',
      content: <GeralCadastro newClient={newClient} handleInputChange={handleInputChange} />
    },
    {
      key: 'financeiro',
      label: 'Financeiro',
      icon: 'chart',
      content: <FinanceiroCadastro newClient={newClient} handleInputChange={handleInputChange} />
    },
    {
      key: 'comercial',
      label: 'Comercial',
      icon: 'building',
      content: <ComercialCadastro newClient={newClient} handleInputChange={handleInputChange} />
    },
    {
      key: 'técnica',
      label: 'Técnica',
      icon: 'config',
      content: <TecnicaCadastro newClient={newClient} handleInputChange={handleInputChange} />
    },
    {
      key: 'contrato',
      label: 'Contrato',
      icon: 'folder',
      content: <ContratoCadastro newClient={newClient} handleInputChange={handleInputChange} />
    },
    {
      key: 'itens',
      label: 'Itens',
      icon: 'layer',
      content: <ItensCadastro newClient={newClient} handleInputChange={handleInputChange} />
    },
    {
      key: 'observacoes',
      label: 'Observação',
      icon: 'config',
      content: <ObservacaoCadastro newClient={newClient} handleInputChange={handleInputChange} />
    }
  ];

  return (
    <div className='cliente-cadastro-container'>
      {loading && <LoadingSpinner />}
      
      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="minimal"
      />
      
      <div className='button-container mt-6'>
        <button 
          className='visualizar-modal-button' 
          onClick={handleSave} 
          disabled={loading}
        >
          Salvar Cliente
        </button>
      </div>
    </div>
  );
};

export default Cadastro;
